var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuseum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.975,9.013V5.249a.439.439,0,0,0-.878,0V9.013a.439.439,0,0,0,.878,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.481,4.522a.443.443,0,0,0,.107-.014L7.781,3.453,12,4.509a.443.443,0,0,0,.532-.32.439.439,0,0,0-.319-.532L7.887,2.574a.431.431,0,0,0-.214,0l-4.3,1.082a.439.439,0,0,0,.107.865Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.283,10.139a.438.438,0,0,0,.439.438h8.147a.439.439,0,0,0,0-.877H3.722A.438.438,0,0,0,3.283,10.139Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.871,11.19H2.719a.439.439,0,1,0,0,.878H12.871a.439.439,0,0,0,0-.878Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,9.013V5.249a.439.439,0,1,0-.877,0V9.013a.439.439,0,1,0,.877,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.234,9.013V5.249a.439.439,0,1,0-.877,0V9.013a.439.439,0,1,0,.877,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.864,9.013V5.249a.439.439,0,1,0-.878,0V9.013a.439.439,0,1,0,.878,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.493,9.013V5.249a.439.439,0,0,0-.878,0V9.013a.439.439,0,0,0,.878,0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/MUSEUM.36005b5086de9ee750df4a75fbb0c773.svg";
export { ForwardRef as ReactComponent };